import Vue from "vue";

Vue.mixin({
    methods: {
        capitalizeFirstLetter(str) {
            return str.toUpperCase();
        },
        HumanReadableDateFormat(date, onlyDate = false) {
            const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June",
            "July", "Aug", "Sept", "Oct", "Nov", "Dec"
            ];
            let dt = new Date(date);
            if (dt == "Invalid Date") {
                return "-";
            }
            let day = ("0" + dt.getDate()).slice(-2);
            let month = dt.getMonth();
            let year = dt.getFullYear();
            let hour = ("0" + dt.getHours()).slice(-2);
            let minute = ("0" + dt.getMinutes()).slice(-2);
            let seconds = ("0" + dt.getSeconds()).slice(-2);
            if (onlyDate) {
                return day + " " + monthNames[month] + " " + year;
            } else {
                return day + " " + monthNames[month] + " " + year + " " + hour + ":" + minute + ":" + seconds;
            }
        },
        ReplaceString(str, split,join) {
            if (str) {
                return str.split(split).join(join);
            } else {
                return str;
            }
        },
        WhiteLabellingTitle() {
            let host = window.location.host;
            if (host == "localhost:8080" || host == "b2b.novaemm.com") {
                return "NovaEMM";
            } else {
                return host.split(".")[1].charAt(0).toUpperCase() + host.split(".")[1].slice(1)
            }   
        },
        GetServerBaseUrl() {
            return process.env.VUE_APP_API_BASE_URL
        },
        GetCountryList() {
            return [{"country":"Afghanistan","code":"93","iso":"AF"},
          {"country":"Albania","code":"355","iso":"AL"},
          {"country":"Algeria","code":"213","iso":"DZ"},
          {"country":"American Samoa","code":"1-684","iso":"AS"},
          {"country":"Andorra","code":"376","iso":"AD"},
          {"country":"Angola","code":"244","iso":"AO"},
          {"country":"Anguilla","code":"1-264","iso":"AI"},
          {"country":"Antarctica","code":"672","iso":"AQ"},
          {"country":"Antigua and Barbuda","code":"1-268","iso":"AG"},
          {"country":"Argentina","code":"54","iso":"AR"},
          {"country":"Armenia","code":"374","iso":"AM"},
          {"country":"Aruba","code":"297","iso":"AW"},
          {"country":"Australia","code":"61","iso":"AU"},
          {"country":"Austria","code":"43","iso":"AT"},
          {"country":"Azerbaijan","code":"994","iso":"AZ"},
          {"country":"Bahamas","code":"1-242","iso":"BS"},
          {"country":"Bahrain","code":"973","iso":"BH"},
          {"country":"Bangladesh","code":"880","iso":"BD"},
          {"country":"Barbados","code":"1-246","iso":"BB"},
          {"country":"Belarus","code":"375","iso":"BY"},
          {"country":"Belgium","code":"32","iso":"BE"},
          {"country":"Belize","code":"501","iso":"BZ"},
          {"country":"Benin","code":"229","iso":"BJ"},
          {"country":"Bermuda","code":"1-441","iso":"BM"},
          {"country":"Bhutan","code":"975","iso":"BT"},
          {"country":"Bolivia","code":"591","iso":"BO"},
          {"country":"Bosnia and Herzegovina","code":"387","iso":"BA"},
          {"country":"Botswana","code":"267","iso":"BW"},
          {"country":"Brazil","code":"55","iso":"BR"},
          {"country":"British Indian Ocean Territory","code":"246","iso":"IO"},
          {"country":"British Virgin Islands","code":"1-284","iso":"VG"},
          {"country":"Brunei","code":"673","iso":"BN"},
          {"country":"Bulgaria","code":"359","iso":"BG"},
          {"country":"Burkina Faso","code":"226","iso":"BF"},
          {"country":"Burundi","code":"257","iso":"BI"},
          {"country":"Cambodia","code":"855","iso":"KH"},
          {"country":"Cameroon","code":"237","iso":"CM"},
          {"country":"Cape Verde","code":"238","iso":"CV"},
          {"country":"Cayman Islands","code":"1-345","iso":"KY"},
          {"country":"Central African Republic","code":"236","iso":"CF"},
          {"country":"Chad","code":"235","iso":"TD"},
          {"country":"Chile","code":"56","iso":"CL"},
          {"country":"China","code":"86","iso":"CN"},
          {"country":"Colombia","code":"57","iso":"CO"},
          {"country":"Comoros","code":"269","iso":"KM"},
          {"country":"Cook Islands","code":"682","iso":"CK"},
          {"country":"Costa Rica","code":"506","iso":"CR"},
          {"country":"Croatia","code":"385","iso":"HR"},
          {"country":"Cuba","code":"53","iso":"CU"},
          {"country":"Curacao","code":"599","iso":"CW"},
          {"country":"Cyprus","code":"357","iso":"CY"},
          {"country":"Czech Republic","code":"420","iso":"CZ"},
          {"country":"Democratic Republic of the Congo","code":"243","iso":"CD"},
          {"country":"Denmark","code":"45","iso":"DK"},
          {"country":"Djibouti","code":"253","iso":"DJ"},
          {"country":"Dominica","code":"1-767","iso":"DM"},
          {"country":"Dominican Republic","code":"1-809, 1-829, 1-849","iso":"DO"},
          {"country":"East Timor","code":"670","iso":"TL"},
          {"country":"Ecuador","code":"593","iso":"EC"},
          {"country":"Egypt","code":"20","iso":"EG"},
          {"country":"El Salvador","code":"503","iso":"SV"},
          {"country":"Equatorial Guinea","code":"240","iso":"GQ"},
          {"country":"Eritrea","code":"291","iso":"ER"},
          {"country":"Estonia","code":"372","iso":"EE"},
          {"country":"Ethiopia","code":"251","iso":"ET"},
          {"country":"Falkland Islands","code":"500","iso":"FK"},
          {"country":"Faroe Islands","code":"298","iso":"FO"},
          {"country":"Fiji","code":"679","iso":"FJ"},
          {"country":"Finland","code":"358","iso":"FI"},
          {"country":"France","code":"33","iso":"FR"},
          {"country":"French Polynesia","code":"689","iso":"PF"},
          {"country":"Gabon","code":"241","iso":"GA"},
          {"country":"Gambia","code":"220","iso":"GM"},
          {"country":"Georgia","code":"995","iso":"GE"},
          {"country":"Germany","code":"49","iso":"DE"},
          {"country":"Ghana","code":"233","iso":"GH"},
          {"country":"Gibraltar","code":"350","iso":"GI"},
          {"country":"Greece","code":"30","iso":"GR"},
          {"country":"Greenland","code":"299","iso":"GL"},
          {"country":"Grenada","code":"1-473","iso":"GD"},
          {"country":"Guam","code":"1-671","iso":"GU"},
          {"country":"Guatemala","code":"502","iso":"GT"},
          {"country":"Guernsey","code":"44-1481","iso":"GG"},
          {"country":"Guinea","code":"224","iso":"GN"},
          {"country":"Guinea-Bissau","code":"245","iso":"GW"},
          {"country":"Guyana","code":"592","iso":"GY"},
          {"country":"Haiti","code":"509","iso":"HT"},
          {"country":"Honduras","code":"504","iso":"HN"},
          {"country":"Hong Kong","code":"852","iso":"HK"},
          {"country":"Hungary","code":"36","iso":"HU"},
          {"country":"Iceland","code":"354","iso":"IS"},
          {"country":"India","code":"91","iso":"IN"},
          {"country":"Indonesia","code":"62","iso":"ID"},
          {"country":"Iran","code":"98","iso":"IR"},
          {"country":"Iraq","code":"964","iso":"IQ"},
          {"country":"Ireland","code":"353","iso":"IE"},
          {"country":"Isle of Man","code":"44-1624","iso":"IM"},
          {"country":"Israel","code":"972","iso":"IL"},
          {"country":"Italy","code":"39","iso":"IT"},
          {"country":"Ivory Coast","code":"225","iso":"CI"},
          {"country":"Jamaica","code":"1-876","iso":"JM"},
          {"country":"Japan","code":"81","iso":"JP"},
          {"country":"Jersey","code":"44-1534","iso":"JE"},
          {"country":"Jordan","code":"962","iso":"JO"},
          {"country":"Kenya","code":"254","iso":"KE"},
          {"country":"Kiribati","code":"686","iso":"KI"},
          {"country":"Kosovo","code":"383","iso":"XK"},
          {"country":"Kuwait","code":"965","iso":"KW"},
          {"country":"Kyrgyzstan","code":"996","iso":"KG"},
          {"country":"Laos","code":"856","iso":"LA"},
          {"country":"Latvia","code":"371","iso":"LV"},
          {"country":"Lebanon","code":"961","iso":"LB"},
          {"country":"Lesotho","code":"266","iso":"LS"},
          {"country":"Liberia","code":"231","iso":"LR"},
          {"country":"Libya","code":"218","iso":"LY"},
          {"country":"Liechtenstein","code":"423","iso":"LI"},
          {"country":"Lithuania","code":"370","iso":"LT"},
          {"country":"Luxembourg","code":"352","iso":"LU"},
          {"country":"Macao","code":"853","iso":"MO"},
          {"country":"Macedonia","code":"389","iso":"MK"},
          {"country":"Madagascar","code":"261","iso":"MG"},
          {"country":"Malawi","code":"265","iso":"MW"},
          {"country":"Malaysia","code":"60","iso":"MY"},
          {"country":"Maldives","code":"960","iso":"MV"},
          {"country":"Mali","code":"223","iso":"ML"},
          {"country":"Malta","code":"356","iso":"MT"},
          {"country":"Marshall Islands","code":"692","iso":"MH"},
          {"country":"Mauritania","code":"222","iso":"MR"},
          {"country":"Mauritius","code":"230","iso":"MU"},
          {"country":"Mayotte","code":"262","iso":"YT"},
          {"country":"Mexico","code":"52","iso":"MX"},
          {"country":"Micronesia","code":"691","iso":"FM"},
          {"country":"Moldova","code":"373","iso":"MD"},
          {"country":"Monaco","code":"377","iso":"MC"},
          {"country":"Mongolia","code":"976","iso":"MN"},
          {"country":"Montenegro","code":"382","iso":"ME"},
          {"country":"Montserrat","code":"1-664","iso":"MS"},
          {"country":"Morocco","code":"212","iso":"MA"},
          {"country":"Mozambique","code":"258","iso":"MZ"},
          {"country":"Myanmar","code":"95","iso":"MM"},
          {"country":"Namibia","code":"264","iso":"NA"},
          {"country":"Nauru","code":"674","iso":"NR"},
          {"country":"Nepal","code":"977","iso":"NP"},
          {"country":"Netherlands","code":"31","iso":"NL"},
          {"country":"New Caledonia","code":"687","iso":"NC"},
          {"country":"New Zealand","code":"64","iso":"NZ"},
          {"country":"Nicaragua","code":"505","iso":"NI"},
          {"country":"Niger","code":"227","iso":"NE"},
          {"country":"Nigeria","code":"234","iso":"NG"},
          {"country":"Niue","code":"683","iso":"NU"},
          {"country":"North Korea","code":"850","iso":"KP"},
          {"country":"Northern Mariana Islands","code":"1-670","iso":"MP"},
          {"country":"Oman","code":"968","iso":"OM"},
          {"country":"Pakistan","code":"92","iso":"PK"},
          {"country":"Palau","code":"680","iso":"PW"},
          {"country":"Palestine","code":"970","iso":"PS"},
          {"country":"Panama","code":"507","iso":"PA"},
          {"country":"Papua New Guinea","code":"675","iso":"PG"},
          {"country":"Paraguay","code":"595","iso":"PY"},
          {"country":"Peru","code":"51","iso":"PE"},
          {"country":"Philippines","code":"63","iso":"PH"},
          {"country":"Poland","code":"48","iso":"PL"},
          {"country":"Portugal","code":"351","iso":"PT"},
          {"country":"Puerto Rico","code":"1-787, 1-939","iso":"PR"},
          {"country":"Qatar","code":"974","iso":"QA"},
          {"country":"Republic of the Congo","code":"242","iso":"CG"},
          {"country":"Romania","code":"40","iso":"RO"},
          {"country":"Russia","code":"7","iso":"RU"},
          {"country":"Rwanda","code":"250","iso":"RW"},
          {"country":"Saint Helena","code":"290","iso":"SH"},
          {"country":"Saint Kitts and Nevis","code":"1-869","iso":"KN"},
          {"country":"Saint Lucia","code":"1-758","iso":"LC"},
          {"country":"Saint Martin","code":"590","iso":"MF"},
          {"country":"Saint Pierre and Miquelon","code":"508","iso":"PM"},
          {"country":"Saint Vincent and the Grenadines","code":"1-784","iso":"VC"},
          {"country":"Samoa","code":"685","iso":"WS"},
          {"country":"San Marino","code":"378","iso":"SM"},
          {"country":"Sao Tome and Principe","code":"239","iso":"ST"},
          {"country":"Saudi Arabia","code":"966","iso":"SA"},
          {"country":"Senegal","code":"221","iso":"SN"},
          {"country":"Serbia","code":"381","iso":"RS"},
          {"country":"Seychelles","code":"248","iso":"SC"},
          {"country":"Sierra Leone","code":"232","iso":"SL"},
          {"country":"Singapore","code":"65","iso":"SG"},
          {"country":"Sint Maarten","code":"1-721","iso":"SX"},
          {"country":"Slovakia","code":"421","iso":"SK"},
          {"country":"Slovenia","code":"386","iso":"SI"},
          {"country":"Solomon Islands","code":"677","iso":"SB"},
          {"country":"Somalia","code":"252","iso":"SO"},
          {"country":"South Africa","code":"27","iso":"ZA"},
          {"country":"South Korea","code":"82","iso":"KR"},
          {"country":"South Sudan","code":"211","iso":"SS"},
          {"country":"Spain","code":"34","iso":"ES"},
          {"country":"Sri Lanka","code":"94","iso":"LK"},
          {"country":"Sudan","code":"249","iso":"SD"},
          {"country":"Suriname","code":"597","iso":"SR"},
          {"country":"Svalbard and Jan Mayen","code":"47","iso":"SJ"},
          {"country":"Swaziland","code":"268","iso":"SZ"},
          {"country":"Sweden","code":"46","iso":"SE"},
          {"country":"Switzerland","code":"41","iso":"CH"},
          {"country":"Syria","code":"963","iso":"SY"},
          {"country":"Taiwan","code":"886","iso":"TW"},
          {"country":"Tajikistan","code":"992","iso":"TJ"},
          {"country":"Tanzania","code":"255","iso":"TZ"},
          {"country":"Thailand","code":"66","iso":"TH"},
          {"country":"Togo","code":"228","iso":"TG"},
          {"country":"Tokelau","code":"690","iso":"TK"},
          {"country":"Tonga","code":"676","iso":"TO"},
          {"country":"Trinidad and Tobago","code":"1-868","iso":"TT"},
          {"country":"Tunisia","code":"216","iso":"TN"},
          {"country":"Turkey","code":"90","iso":"TR"},
          {"country":"Turkmenistan","code":"993","iso":"TM"},
          {"country":"Turks and Caicos Islands","code":"1-649","iso":"TC"},
          {"country":"Tuvalu","code":"688","iso":"TV"},
          {"country":"U.S. Virgin Islands","code":"1-340","iso":"VI"},
          {"country":"Uganda","code":"256","iso":"UG"},
          {"country":"Ukraine","code":"380","iso":"UA"},
          {"country":"United Arab Emirates","code":"971","iso":"AE"},
          {"country":"United Kingdom","code":"44","iso":"GB"},
          {"country":"United States","code":"1","iso":"US"},
          {"country":"Uruguay","code":"598","iso":"UY"},
          {"country":"Uzbekistan","code":"998","iso":"UZ"},
          {"country":"Vanuatu","code":"678","iso":"VU"},
          {"country":"Vatican","code":"379","iso":"VA"},
          {"country":"Venezuela","code":"58","iso":"VE"},
          {"country":"Vietnam","code":"84","iso":"VN"},
          {"country":"Wallis and Futuna","code":"681","iso":"WF"},
          {"country":"Yemen","code":"967","iso":"YE"},
          {"country":"Zambia","code":"260","iso":"ZM"},
          {"country":"Zimbabwe","code":"263","iso":"ZW"}];
        },

        NumberTODecimal(amount) {
            return amount.toFixed(2);
        },
        timeSlot() {
            return ['07:00','08:00','09:00','10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00'];
        },
        getDay(date) {
            let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            let d = new Date(date);
            return days[d.getDay()];
        },
        formatCurrency(amount) {
            let formatter = new Intl.NumberFormat('en-GB', {
                style: 'currency',
                currency: 'GBP',
                minimumFractionDigits: 2
            })
            return formatter.format(amount);
        },
        timezoneArray() {
            return [
                'Europe/Andorra',
                'Asia/Dubai',
                'Asia/Kabul',
                'Europe/Tirane',
                'Asia/Yerevan',
                'Antarctica/Casey',
                'Antarctica/Davis',
                'Antarctica/DumontDUrville',
                'Antarctica/Mawson',
                'Antarctica/Palmer',
                'Antarctica/Rothera',
                'Antarctica/Syowa',
                'Antarctica/Troll',
                'Antarctica/Vostok',
                'America/Argentina/Buenos_Aires',
                'America/Argentina/Cordoba',
                'America/Argentina/Salta',
                'America/Argentina/Jujuy',
                'America/Argentina/Tucuman',
                'America/Argentina/Catamarca',
                'America/Argentina/La_Rioja',
                'America/Argentina/San_Juan',
                'America/Argentina/Mendoza',
                'America/Argentina/San_Luis',
                'America/Argentina/Rio_Gallegos',
                'America/Argentina/Ushuaia',
                'Pacific/Pago_Pago',
                'Europe/Vienna',
                'Australia/Lord_Howe',
                'Antarctica/Macquarie',
                'Australia/Hobart',
                'Australia/Currie',
                'Australia/Melbourne',
                'Australia/Sydney',
                'Australia/Broken_Hill',
                'Australia/Brisbane',
                'Australia/Lindeman',
                'Australia/Adelaide',
                'Australia/Darwin',
                'Australia/Perth',
                'Australia/Eucla',
                'Asia/Baku',
                'America/Barbados',
                'Asia/Dhaka',
                'Europe/Brussels',
                'Europe/Sofia',
                'Atlantic/Bermuda',
                'Asia/Brunei',
                'America/La_Paz',
                'America/Noronha',
                'America/Belem',
                'America/Fortaleza',
                'America/Recife',
                'America/Araguaina',
                'America/Maceio',
                'America/Bahia',
                'America/Sao_Paulo',
                'America/Campo_Grande',
                'America/Cuiaba',
                'America/Santarem',
                'America/Porto_Velho',
                'America/Boa_Vista',
                'America/Manaus',
                'America/Eirunepe',
                'America/Rio_Branco',
                'America/Nassau',
                'Asia/Thimphu',
                'Europe/Minsk',
                'America/Belize',
                'America/St_Johns',
                'America/Halifax',
                'America/Glace_Bay',
                'America/Moncton',
                'America/Goose_Bay',
                'America/Blanc-Sablon',
                'America/Toronto',
                'America/Nipigon',
                'America/Thunder_Bay',
                'America/Iqaluit',
                'America/Pangnirtung',
                'America/Atikokan',
                'America/Winnipeg',
                'America/Rainy_River',
                'America/Resolute',
                'America/Rankin_Inlet',
                'America/Regina',
                'America/Swift_Current',
                'America/Edmonton',
                'America/Cambridge_Bay',
                'America/Yellowknife',
                'America/Inuvik',
                'America/Creston',
                'America/Dawson_Creek',
                'America/Fort_Nelson',
                'America/Vancouver',
                'America/Whitehorse',
                'America/Dawson',
                'Indian/Cocos',
                'Europe/Zurich',
                'Africa/Abidjan',
                'Pacific/Rarotonga',
                'America/Santiago',
                'America/Punta_Arenas',
                'Pacific/Easter',
                'Asia/Shanghai',
                'Asia/Urumqi',
                'America/Bogota',
                'America/Costa_Rica',
                'America/Havana',
                'Atlantic/Cape_Verde',
                'America/Curacao',
                'Indian/Christmas',
                'Asia/Nicosia',
                'Asia/Famagusta',
                'Europe/Prague',
                'Europe/Berlin',
                'Europe/Copenhagen',
                'America/Santo_Domingo',
                'Africa/Algiers',
                'America/Guayaquil',
                'Pacific/Galapagos',
                'Europe/Tallinn',
                'Africa/Cairo',
                'Africa/El_Aaiun',
                'Europe/Madrid',
                'Africa/Ceuta',
                'Atlantic/Canary',
                'Europe/Helsinki',
                'Pacific/Fiji',
                'Atlantic/Stanley',
                'Pacific/Chuuk',
                'Pacific/Pohnpei',
                'Pacific/Kosrae',
                'Atlantic/Faroe',
                'Europe/Paris',
                'Europe/London',
                'Asia/Tbilisi',
                'America/Cayenne',
                'Africa/Accra',
                'Europe/Gibraltar',
                'America/Godthab',
                'America/Danmarkshavn',
                'America/Scoresbysund',
                'America/Thule',
                'Europe/Athens',
                'Atlantic/South_Georgia',
                'America/Guatemala',
                'Pacific/Guam',
                'Africa/Bissau',
                'America/Guyana',
                'Asia/Hong_Kong',
                'America/Tegucigalpa',
                'America/Port-au-Prince',
                'Europe/Budapest',
                'Asia/Jakarta',
                'Asia/Pontianak',
                'Asia/Makassar',
                'Asia/Jayapura',
                'Europe/Dublin',
                'Asia/Jerusalem',
                'Asia/Kolkata',
                'Asia/Calcutta',
                'Indian/Chagos',
                'Asia/Baghdad',
                'Asia/Tehran',
                'Atlantic/Reykjavik',
                'Europe/Rome',
                'America/Jamaica',
                'Asia/Amman',
                'Asia/Tokyo',
                'Africa/Nairobi',
                'Asia/Bishkek',
                'Pacific/Tarawa',
                'Pacific/Enderbury',
                'Pacific/Kiritimati',
                'Asia/Pyongyang',
                'Asia/Seoul',
                'Asia/Almaty',
                'Asia/Qyzylorda',
                'Asia/Qostanay',
                'Asia/Aqtobe',
                'Asia/Aqtau',
                'Asia/Atyrau',
                'Asia/Oral',
                'Asia/Beirut',
                'Asia/Colombo',
                'Africa/Monrovia',
                'Europe/Vilnius',
                'Europe/Luxembourg',
                'Europe/Riga',
                'Africa/Tripoli',
                'Africa/Casablanca',
                'Europe/Monaco',
                'Europe/Chisinau',
                'Pacific/Majuro',
                'Pacific/Kwajalein',
                'Asia/Yangon',
                'Asia/Ulaanbaatar',
                'Asia/Hovd',
                'Asia/Choibalsan',
                'Asia/Macau',
                'America/Martinique',
                'Europe/Malta',
                'Indian/Mauritius',
                'Indian/Maldives',
                'America/Mexico_City',
                'America/Cancun',
                'America/Merida',
                'America/Monterrey',
                'America/Matamoros',
                'America/Mazatlan',
                'America/Chihuahua',
                'America/Ojinaga',
                'America/Hermosillo',
                'America/Tijuana',
                'America/Bahia_Banderas',
                'Asia/Kuala_Lumpur',
                'Asia/Kuching',
                'Africa/Maputo',
                'Africa/Windhoek',
                'Pacific/Noumea',
                'Pacific/Norfolk',
                'Africa/Lagos',
                'America/Managua',
                'Europe/Amsterdam',
                'Europe/Oslo',
                'Asia/Kathmandu',
                'Pacific/Nauru',
                'Pacific/Niue',
                'Pacific/Auckland',
                'Pacific/Chatham',
                'America/Panama',
                'America/Lima',
                'Pacific/Tahiti',
                'Pacific/Marquesas',
                'Pacific/Gambier',
                'Pacific/Port_Moresby',
                'Pacific/Bougainville',
                'Asia/Manila',
                'Asia/Karachi',
                'Europe/Warsaw',
                'America/Miquelon',
                'Pacific/Pitcairn',
                'America/Puerto_Rico',
                'Asia/Gaza',
                'Asia/Hebron',
                'Europe/Lisbon',
                'Atlantic/Madeira',
                'Atlantic/Azores',
                'Pacific/Palau',
                'America/Asuncion',
                'Asia/Qatar',
                'Indian/Reunion',
                'Europe/Bucharest',
                'Europe/Belgrade',
                'Europe/Kaliningrad',
                'Europe/Moscow',
                'Europe/Simferopol',
                'Europe/Kirov',
                'Europe/Astrakhan',
                'Europe/Volgograd',
                'Europe/Saratov',
                'Europe/Ulyanovsk',
                'Europe/Samara',
                'Asia/Yekaterinburg',
                'Asia/Omsk',
                'Asia/Novosibirsk',
                'Asia/Barnaul',
                'Asia/Tomsk',
                'Asia/Novokuznetsk',
                'Asia/Krasnoyarsk',
                'Asia/Irkutsk',
                'Asia/Chita',
                'Asia/Yakutsk',
                'Asia/Khandyga',
                'Asia/Vladivostok',
                'Asia/Ust-Nera',
                'Asia/Magadan',
                'Asia/Sakhalin',
                'Asia/Srednekolymsk',
                'Asia/Kamchatka',
                'Asia/Anadyr',
                'Asia/Riyadh',
                'Pacific/Guadalcanal',
                'Indian/Mahe',
                'Africa/Khartoum',
                'Europe/Stockholm',
                'Asia/Singapore',
                'America/Paramaribo',
                'Africa/Juba',
                'Africa/Sao_Tome',
                'America/El_Salvador',
                'Asia/Damascus',
                'America/Grand_Turk',
                'Africa/Ndjamena',
                'Indian/Kerguelen',
                'Asia/Bangkok',
                'Asia/Dushanbe',
                'Pacific/Fakaofo',
                'Asia/Dili',
                'Asia/Ashgabat',
                'Africa/Tunis',
                'Pacific/Tongatapu',
                'Europe/Istanbul',
                'America/Port_of_Spain',
                'Pacific/Funafuti',
                'Asia/Taipei',
                'Europe/Kiev',
                'Europe/Uzhgorod',
                'Europe/Zaporozhye',
                'Pacific/Wake',
                'America/New_York',
                'America/Detroit',
                'America/Kentucky/Louisville',
                'America/Kentucky/Monticello',
                'America/Indiana/Indianapolis',
                'America/Indiana/Vincennes',
                'America/Indiana/Winamac',
                'America/Indiana/Marengo',
                'America/Indiana/Petersburg',
                'America/Indiana/Vevay',
                'America/Chicago',
                'America/Indiana/Tell_City',
                'America/Indiana/Knox',
                'America/Menominee',
                'America/North_Dakota/Center',
                'America/North_Dakota/New_Salem',
                'America/North_Dakota/Beulah',
                'America/Denver',
                'America/Boise',
                'America/Phoenix',
                'America/Los_Angeles',
                'America/Anchorage',
                'America/Juneau',
                'America/Sitka',
                'America/Metlakatla',
                'America/Yakutat',
                'America/Nome',
                'America/Adak',
                'Pacific/Honolulu',
                'America/Montevideo',
                'Asia/Samarkand',
                'Asia/Tashkent',
                'America/Caracas',
                'Asia/Ho_Chi_Minh',
                'Pacific/Efate',
                'Pacific/Wallis',
                'Pacific/Apia',
                'Africa/Johannesburg'
              ];              
        }
    }
})